module.exports = __webpack_public_path__ + "static/media/badeplass.a4e4be55.svg";